export default "__VITE_ASSET__DKujW7iH__"